import * as React from 'react';
import { useMemo } from 'react';
import { CheckoutOrderFragment } from '@websky/graphql';
import { ControlType } from './components/FlightInfoCardControls/FlightInfoCardControls';
import { CdnIcon } from '@shared/ui';
import { useHistory } from '@shared/routing';
import { useTranslation } from 'react-i18next';

export const useFlightInfoCardControls = (order: CheckoutOrderFragment): ControlType[] => {
	const history = useHistory();
	const { t } = useTranslation('FlightInfoCard');

	const controls: ControlType[] = useMemo(() => {
		const controls: ControlType[] = [];

		if (order.exareInfo?.isExchangeVariantsAvailable || !!order.exareInfo?.lastExchange) {
			controls.push({
				icon: <CdnIcon icon={'Action/Show Calendar'} />,
				name: t('Change'),
				onClick: () => {
					history.push(`exchange`);
				}
			});
		}

		if (order.exareInfo?.isGetRefundInfoAvailable || order.exareInfo?.refundAvailability) {
			controls.push({
				icon: <CdnIcon icon={'Services/Refundable'} />,
				name: t('Refund'),
				onClick: () => {
					history.push(`refund`);
				}
			});
		}

		if (order.exareInfo?.gdsServicesRefundAvailability) {
			controls.push({
				icon: <CdnIcon icon={'Services/return'} />,
				name: t('Refund services'),
				onClick: () => {
					history.push(`refund-services`);
				}
			});
		}

		return controls;
	}, [order, history, t]);

	return controls;
};
